var _rect, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.731445,
    y: 0.222656,
    width: 48.3862,
    height: 48.3862,
    rx: 4.83862,
    fill: "#0081AF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.731445,
    y: 0.222656,
    width: 48.3862,
    height: 48.3862,
    rx: 4.83862,
    fill: "url(#paint0_linear_14061_44994)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1671 23.655C24.1662 23.653 24.1638 23.6522 24.1619 23.6531C24.1603 23.6539 24.1594 23.6556 24.1597 23.6574C24.3984 24.9169 24.8521 26.1025 25.3485 27.2925C26.2998 29.5744 27.6599 31.8626 29.0843 33.873C30.5005 35.8725 31.963 37.4582 33.6813 39.1748C33.7336 39.227 33.7199 39.3158 33.657 39.3546C33.4709 39.4693 33.2892 39.6128 33.097 39.6837C32.9526 39.737 32.8016 39.6656 32.6945 39.555C31.4916 38.3131 30.3993 37.1015 29.3564 35.6492C29.3215 35.6006 29.2562 35.5805 29.1964 35.582C29.1788 35.5825 29.1624 35.5822 29.1496 35.5817C29.1324 35.5811 29.1152 35.582 29.0982 35.5853C27.3045 35.9317 25.2693 35.7794 23.5045 34.9392C21.3506 33.9139 19.7313 31.8967 18.4608 29.8168C17.1181 27.6174 16.3659 25.0609 15.9795 22.5705C15.6234 20.2766 15.7504 18.012 15.9994 15.7818C16.238 13.6446 16.7845 11.5518 17.3483 9.5239C17.3947 9.35536 17.4381 9.18505 17.4834 9.01566C17.4913 8.98578 17.5238 8.96978 17.5524 8.98156C17.8078 9.05829 18.0605 9.14503 18.3148 9.22651C20.3534 9.87916 22.301 10.7023 24.1724 11.8784C27.2221 13.7951 30.2751 16.5476 32.3044 19.7218C34.12 22.5612 35.3609 26.5456 34.667 29.7921C34.5182 30.489 34.2691 31.1153 33.9444 31.6833C32.7752 33.7291 29.8926 33.3961 28.4978 31.4969C28.1857 31.0719 27.8847 30.6404 27.5957 30.2065C26.5233 28.5979 25.6643 26.8257 24.8296 25.0723C24.5995 24.5902 24.3793 24.124 24.1671 23.655Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14061_44994",
    x1: 24.9246,
    y1: 0.222656,
    x2: 24.9246,
    y2: 48.6089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0081AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005D7E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.400f1c61166cad87d9919a6e93046224.svg";
export { ForwardRef as ReactComponent };